module.exports = __webpack_public_path__ + "static/media/53.3b49f426.png";